var map = {
	"./Frame 1.jpg": 18488,
	"./Frame 2.jpg": 11860,
	"./Frame 21.jpg": 50424,
	"./Frame 22.jpg": 52176,
	"./Frame 23.jpg": 38884,
	"./Frame 3.jpg": 65768,
	"./Frame 4.jpg": 87164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28372;